module.exports = __webpack_public_path__ + "img/wx-img1.97337921.png";